<template>
  <div></div>
</template>

<script>
import { _local } from '@/utils/storage'
import { getReportSetting } from '@/server/user'
export default {
  data() {
    return {
      hasClose: _local.get('hasClose') || false,
      userStatus: _local.get('hasBindData') || {},
    }
  },
  async mounted() {
    await this.getSetting()
    this.checkBoardList()
  },
  computed: {
    boardMenu() {
      return this.$store.state.menu.boardMenu
    },
    isOwnMerchant() {
      return this.$store.getters.getIsOwnMerchant
    },
    isToIndex() {
      let flag = false
      // 如果当前商家是该账户下的,并且没关闭过引导
      if (this.isOwnMerchant && !this.hasClose) {
        // flag = true
        // 并且当前有未完成设置
        for (let key in this.userStatus) {
          if (!this.userStatus[key]) {
            flag = true
            break
          }
        }
      }
      return flag
    },
  },
  methods: {
    async getSetting() {
      const { data } = await getReportSetting(1)
      if (data.code === this.$code && data.data.config) {
        this.hasClose = JSON.parse(data.data.config).hasClose
        _local.set('hasClose', this.hasClose)
      } else {
        _local.set('hasClose', false)
      }
    },
    checkBoardList() {
      if (this.isToIndex) {
        this.$router.replace('/index')
        return
      }
      // 如果有报表则显示报表，没有则跳转原有菜单
      let platform = this.boardMenu.platform.filter(el => el.children && el.children.length)
      let personal = this.boardMenu.personal.filter(el => el.children && el.children.length)
      if (platform.length && this.$auth('data-board-customer::show-list')) {
        this.$router.replace({ path: platform[0].children[0].url })
      } else if (personal.length) {
        this.$router.replace({ path: personal[0].children[0].url })
      } else {
        this.$router.replace('/index')
      }
    },
  },
}
</script>

<style></style>
